import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect} from 'react-redux'
import Selector from "../../../Selector";
import { periodData } from "../../mock";

/** Search for interval */
 const SearchPeriodField=({
  action,
  mainGroup,
  onDaySelected,
  className,
  getPeriod,
  setPeriod,
  filterPeriod
}) => {
  
  useEffect(()=>{
    getPeriod();
  },[getPeriod])
  
  return (
    (action.indexOf("adicionar-documentos") !== -1 ||
      action.indexOf("carregamentos-transportadora") !== -1) &&
    ["support", "backoffice", "transporter"].indexOf(mainGroup) !== -1 && (
      <Selector
        value={{ label: `${filterPeriod} dias`, value: filterPeriod }}
        options={periodData}
        label="Listando últimas"
        className={className}
        defaultValue={{ label: "3 dias", value: 3 }}
        onChange={(data) => {
          setPeriod(data.value);
        }}
        isMulti={false}
        width="120px"
      />
    )
  );
}

SearchPeriodField.propTypes = {
  action: PropTypes.string.isRequired,
  mainGroup: PropTypes.string.isRequired,
  onDaySelected: PropTypes.func,
};


const mapState = (state) => ({
  filterPeriod: state.branches.filterPeriod,
});

const mapDispatch = (dispatch) => ({
  setPeriod: (payload) => dispatch.branches.setPeriod(payload),
  getPeriod: (payload) => dispatch.branches.setPeriodAsync(payload)
}); 

export default connect(mapState, mapDispatch)(SearchPeriodField);